import ViewModelCore from "./ViewModel"

export default class DataDeCarregamentoViewModel extends ViewModelCore{
    constructor(dataCarregamento = undefined, quantidade = 0, ordemCompra = undefined){
        super();
        this.DataCarregamento = dataCarregamento;
        this.Quantidade = quantidade;
        this.OrdemDeCompra = ordemCompra;
        this.PedidoDataCarregamentoId = undefined;
        this.Observacao = undefined;
        this.QuantidadeTotal = undefined;

    }

}